export interface IAccountState {
  id?: number;
  message?: string;
}

export class AccountState implements IAccountState {
  constructor(public id?: number, public message?: string) {}
}
